import type { PpdfSouhlasyStahniVsechnySouhlasyPpdfParams } from '@gov-nx/api';
import {
	ppdfDownloadAllConsentsQuery,
	useAxiosInstance,
	useDownloadPoMutation,
} from '@gov-nx/api';
import { useDownloadEvents, useMessageEvents } from '@gov-nx/core/events';
import { LocalizeNameSpaceTypes, useLocale } from '@gov-nx/core/service';

export interface PpdfDownloadAllConsents {
	downloadAllConsents: () => void;
	isDownloading: boolean;
}

export const usePpdfDownloadAllConsents = (
	params: PpdfSouhlasyStahniVsechnySouhlasyPpdfParams
): PpdfDownloadAllConsents => {
	const { axiosInstance } = useAxiosInstance();
	const { download } = useDownloadEvents();
	const { toastMessageSuccess, toastMessageError } = useMessageEvents();
	const { t } = useLocale(LocalizeNameSpaceTypes.Service);

	const { mutate, isLoading } = useDownloadPoMutation(
		ppdfDownloadAllConsentsQuery,
		{
			onSuccess: (props) =>
				download({
					id: 'ppdf-download-all-consents',
					...props,
					callback: (_, success, error) => {
						if (success) {
							toastMessageSuccess(
								t('dokument.stazeni-dokumentu-uspech', {
									fileName: props.fileName,
								})
							);
						}
						if (error) {
							toastMessageError();
						}
					},
				}),
		}
	);

	return {
		downloadAllConsents: () => mutate({ axiosInstance, params }),
		isDownloading: isLoading,
	};
};
